import React, { Fragment, lazy, Suspense } from 'react'
import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Route,
  RouterProvider,
} from 'react-router-dom'
import { useSelector } from 'react-redux'
//
import HomeRoutes from './HomeRoutes'
import CustomerRoutes from './CustomerRoutes'
import TicketsRoutes from './TicketsRoutes'
import AdminRoutes from './AdminRoutes'
import CustomerAssetsRoutes from './CustomerAssetsRoutes'
import InvoiceRoutes from './InvoiceRoutes'
import AppointmentRoutes from './AppointmentRoutes'
import PageNotFound from '../pages/no-page/PageNotFound'

import AuthRoutesWrapper from '../components/layout/AuthRoutesWrapper'
import MainLayout from '../components/layout/MainLayout'
import { USER_ROLES } from '../utils/userRole'

const Login = lazy(() => import('../pages/auth/Login'))
const CustomerLogin = lazy(() => import('../pages/customer/pages/Login'))
const CustomerOTP = lazy(() => import('../pages/customer/pages/OTP'))
const CustomerSetPassword = lazy(() =>
  import('../pages/customer/pages/SetPassword'),
)
const CustomerPassword = lazy(() =>
  import('../pages/customer/pages/Password'),
)

const ROUTES = [
  ...HomeRoutes,
  ...CustomerRoutes,
  ...TicketsRoutes,
  ...AdminRoutes,
  ...CustomerAssetsRoutes,
  ...InvoiceRoutes,
  ...AppointmentRoutes,
]

const routesFromElements = (user_role) =>
  createRoutesFromElements(
    <Fragment>
      <Route element={<AuthRoutesWrapper />}>
        <Route path='/login' Component={Login} />
        {/* <Route path='/forgot-password' Component={ForgotPassword} /> */}
        <Route path='/customer/login' Component={CustomerLogin} />
        <Route path='/customer/otp' Component={CustomerOTP} />
        <Route path='/customer/password' Component={CustomerPassword} />
        <Route path='/customer/set-password' Component={CustomerSetPassword} />
      </Route>
      <Route path='/' element={<MainLayout />}>
        <Route index element={<RoleBasedIndex />} />
        {user_role &&
          ROUTES.map(
            (item, i) =>
              item?.permissions?.includes(user_role) && (
                <Route
                  index={item.index}
                  key={i}
                  path={item.path}
                  Component={item.component}
                />
              ),
          )}
      </Route>
      <Route path='/*' Component={PageNotFound} />
    </Fragment>,
  )

const RoutersList = () => {
  const { user_role } = useSelector((state) => state.auth)
  const router = createBrowserRouter(routesFromElements(user_role))
  return (
    <div className='app-body'>
      <Suspense fallback={<div className='loader'></div>}>
        <div className='d-flex vh-100'>
          <RouterProvider router={router} />
        </div>
      </Suspense>
    </div>
  )
}

export default RoutersList

const RoleBasedIndex = () => {
  const { user_role } = useSelector((state) => state.auth)
  if (user_role === USER_ROLES.ADMIN)
    return <Navigate to='/overview' replace />
  if (user_role === USER_ROLES.USER) return <Navigate to='/ticket' replace />
}
